import PropTypes from 'prop-types';
import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { prism } from 'react-syntax-highlighter/dist/esm/styles/prism';

const Code = ({ codestring, language, ...props }) => {
  const theme = {
    ...prism,
    'pre[class*="language-"]': {
      ...prism['pre[class*="language-"]'],
      margin: '0 0 40px 0',
    },
  };
  return (
    <SyntaxHighlighter {...props} language={language} style={theme}>
      {codestring}
    </SyntaxHighlighter>
  );
};

Code.propTypes = {
  codestring: PropTypes.string,
  language: PropTypes.string,
};

export default Code;
